import React from 'react'
import _ from 'lodash'
import Cookie from 'js-cookie'
import { connect } from 'react-redux'
import { Icon } from 'semantic-ui-react'

import DriverList from './DriverList'

import DriverActions from '../../../reducers/driverReducer'
import MapViewActions from '../../../reducers/mapViewReducer'

class DriversBar extends React.PureComponent {
  componentDidMount() {
    const { loaded, syncDrivers } = this.props

    const shouldSyncDriversCookie = Cookie.get('should_sync_drivers')
    const shouldSyncDrivers = shouldSyncDriversCookie === undefined ? true : (shouldSyncDriversCookie === 'true')

    if (!loaded && shouldSyncDrivers) syncDrivers()
  }

  onOpenMap = () => {
    const { setMapData } = this.props

    setMapData('drivers', null)
  }

  render() {
    const { orders, drivers } = this.props

    return (
      <div style={{ display: 'inline-block' }}>
        <DriverList drivers={drivers} orders={orders} />
        <Icon
          size="large"
          name="map"
          style={{ marginLeft: 5, cursor: 'pointer' }}
          onClick={this.onOpenMap}
        />
      </div>
    )
  }
}

const mapState = ({ drivers }) => ({
  drivers: _.chain(drivers.drivers)
    .filter({ online: true })
    .orderBy(['family_name'], ['asc'])
    .value(),
  loaded: drivers.driverLoaded,
})

const mapDispatch = {
  syncDrivers: DriverActions.syncDrivers,
  setMapData: MapViewActions.setMapData
}

export default connect(
  mapState,
  mapDispatch
)(DriversBar)



// WEBPACK FOOTER //
// ./src/containers/orders/components/DriversBar.js